import script from "./accountManage.vue?vue&type=script&setup=true&lang=js"
export * from "./accountManage.vue?vue&type=script&setup=true&lang=js"

import "./accountManage.vue?vue&type=style&index=0&id=39d535e3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39d535e3"]])

export default __exports__